import actionTypes from './actionTypes';

export const changeAuthorizationUserAttribute = ({ elementId, groupOrUserAttributeId, index }) => ({
    type: actionTypes.SWIMLANE_CHANGE_AUTHORIZATION_USER_ATTRIBUTE,
    payload: { groupElementId: elementId, userAttributeId: groupOrUserAttributeId, index },
});

export const deleteAuthorizationUser = ({ elementId, index }) => ({
    type: actionTypes.SWIMLANE_DELETE_AUTHORIZATION_USER,
    payload: { groupElementId: elementId, index },
});

export const changeAuthorizationGroupAttribute = ({ elementId, groupOrUserAttributeId, index }) => ({
    type: actionTypes.SWIMLANE_CHANGE_AUTHORIZATION_GROUP_ATTRIBUTE,
    payload: { groupElementId: elementId, groupAttributeId: groupOrUserAttributeId, index },
});

export const deleteAuthorizationGroup = ({ elementId, index }) => ({
    type: actionTypes.SWIMLANE_DELETE_AUTHORIZATION_GROUP,
    payload: { groupElementId: elementId, index },
});

export const addAuthorizationUsersOrGroups = (elementId, selections, type) => ({
    type: actionTypes.SWIMLANE_ADD_AUTHORIZATION_USERS_GROUPS_SELECTION,
    payload: { groupElementId: elementId, selections, type },
});

export const setAuthorizationUsersOrGroups = (elementId, selections, type) => ({
    type: actionTypes.SWIMLANE_SET_AUTHORIZATION_USERS_GROUPS_SELECTION,
    payload: { groupElementId: elementId, selections, type },
});

export const setComment = ({ groupElement, comment }) => ({
    type: actionTypes.SWIMLANE_SET_COMMENT,
    payload: {
        groupElement,
        comment,
    },
});

export const setAuthorizationServiceId = ({ groupElement, serviceElementId }) => ({
    type: actionTypes.SWIMLANE_SET_AUTHORIZATION_SERVICE_ID,
    payload: {
        groupElement,
        serviceElementId,
    },
});

export const setAuthorizationSocialStream = ({ groupElement, streamBehaviour }) => ({
    type: actionTypes.SWIMLANE_SET_AUTHORIZATION_SOCIAL_STREAM,
    payload: {
        groupElement,
        streamBehaviour,
    },
});

export const setAuthorizationAuthenticationType = ({ groupElement, authenticationType }) => ({
    type: actionTypes.SWIMLANE_SET_AUTHORIZATION_TYPE,
    payload: {
        groupElement,
        authenticationType,
    },
});
